import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import EngineeringIcon from '@mui/icons-material/Engineering';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { getsales } from '../redux/sales';
import Progress from '../components/Loader';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function BasicModal() {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [customer, setCustomer] = React.useState('none');
  const [unit, setUnit] = React.useState('none');
  const [haullier, setHaullier] = React.useState('none');
  const [chosenHaullier, setChosenHaullier] = React.useState([]);
  const [method, setMethod] = React.useState('none');
  const [driverName, setDriverName] = React.useState('none');
  const [vehicleRegistration, setVehicleRegistration] = React.useState('none');
  const [personName, setPersonName] = React.useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const dispatch = useDispatch();
  const customer_ = useSelector((state) => state.customer || []);
  const haullier_ = useSelector((state) => state.hauler || []);
  const sales = useSelector((state) => state.sales || []);
  const dt = new Date();
  const month = String(dt.getMonth() + 1).padStart(2, '0');
  const year = dt.getFullYear();
  const day = dt.getUTCDate();
  const idmain = `SA${year}0Q${month}00${sales.length % parseInt(day)}`;

  const names = ['Maize', 'Soya Beans', 'Onion', 'Pepper', 'Tomatoes'];

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleChange = (event) => {
    const { target: { value } } = event;
    setPersonName(typeof value === 'string' ? value.split(',') : value);
  };

  const haullierChooser = (data) => {
    setHaullier(data);
    const chosenData = haullier_.filter((bug) => bug.haullier === data);
    setChosenHaullier(chosenData);
    setDriverName('none');
    setVehicleRegistration('none');
  };

  const clearForm = () => {
    setCustomer('none');
    setUnit('none');
    setHaullier('none');
    setChosenHaullier([]);
    setMethod('none');
    setDriverName('none');
    setVehicleRegistration('none');
    setPersonName([]);
    document.getElementById('shippedvia').value = '';
    document.getElementById('fobpoint').value = '';
    document.getElementById('tax').value = '';
    document.getElementById('others').value = '';
    personName.forEach((list, i) => {
      document.getElementById(`${list}${i}`).value = '';
      document.getElementById(`${list}unitp${i}`).value = '';
    });
  };

  const addPurchaseOrder = async () => {
    setLoading(true);
    const list = personName.map((product, i) => ({
      product,
      qty: document.getElementById(`${product}${i}`).value,
      unitp: document.getElementById(`${product}unitp${i}`).value,
    }));
    const contact = chosenHaullier.length
      ? chosenHaullier[0]?.vehicleslist?.find((bug) => bug.drivername === driverName)?.contact || ''
      : '';

    try {
      const res = await axios.post('https://embert.sisrevolution.com/api/sales/addsales/', {
        shippedvia: document.getElementById('shippedvia').value,
        fobpoint: document.getElementById('fobpoint').value,
        tax: document.getElementById('tax').value,
        unit: unit,
        haullier: haullier,
        drivername: driverName,
        drivernumber: contact,
        vehicle: vehicleRegistration,
        purchase: list,
        invoice: idmain,
        customer: customer,
        paymentmethod: method,
        others: document.getElementById('others').value,
      });

      if (res.status === 200) {
        setLoading(false);
        dispatch(getsales({ data: res.data }));
        setSnackbarMessage('Purchase order submitted successfully!');
        setSnackbarOpen(true);
        clearForm();
        setTimeout(() => handleClose(), 1500); // Close dialog after 1.5s
      } else {
        setLoading(false);
        setSnackbarMessage('Failed to submit purchase order.');
        setSnackbarOpen(true);
      }
    } catch (err) {
      setLoading(false);
      setSnackbarMessage('Error submitting purchase order.');
      setSnackbarOpen(true);
    }
  };

  return (
    <div>
      <Button variant="outlined" startIcon={<EngineeringIcon />} onClick={handleOpen}>
        Issue Purchase Order
      </Button>
      <Dialog fullWidth minWidth="sm" open={open} onClose={handleClose} aria-labelledby="customized-dialog-title">
        <DialogTitle id="customized-dialog-title">
          New Purchase Order
          <IconButton onClick={handleClose} style={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="outlined-select-currency-native"
              select
              label="Choose Customer"
              value={customer}
              onChange={(e) => setCustomer(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="none">Choose</option>
              {customer_.map((list) => (
                <option key={list.businessname} value={list.businessname}>
                  {list.businessname}
                </option>
              ))}
            </TextField>
            <FormControl sx={{ m: 1, width: 225 }}>
              <InputLabel id="demo-multiple-checkbox-label">Choose Product(s)</InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={personName}
                onChange={handleChange}
                input={<OutlinedInput label="Choose Product(s)" />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
              >
                {names.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={personName.includes(name)} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {personName.map((list, i) => (
              <div
                key={list + i}
                style={{ border: 'solid', borderWidth: '1px', borderRadius: '5px', borderColor: 'gray', padding: '10px' }}
              >
                <TextField id={`${list}${i}`} label={`${list} Quantity`} type="text" autoComplete="current-text" />
                <TextField
                  id={`${list}unitp${i}`}
                  label={`${list} Unit Price`}
                  type="text"
                  autoComplete="current-text"
                />
              </div>
            ))}
            <TextField
              id="outlined-select-currency-native"
              select
              label="Measuring Unit"
              value={unit}
              onChange={(e) => setUnit(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="none">Choose</option>
              <option value="Kg">Kg</option>
              <option value="Tons">Tons</option>
              <option value="bags">bags</option>
            </TextField>
            <TextField
              id="outlined-select-currency-native"
              select
              label="Choose Haullier"
              value={haullier}
              onChange={(e) => haullierChooser(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="none">Choose</option>
              {haullier_.map((list) => (
                <option key={list.haullier} value={list.haullier}>
                  {list.haullier}
                </option>
              ))}
            </TextField>
            <TextField
              id="outlined-select-currency-native"
              select
              label="Choose Driver"
              value={driverName}
              onChange={(e) => setDriverName(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="none">Choose</option>
              {chosenHaullier.length !== 0 &&
                chosenHaullier[0].vehicleslist?.map((list) => (
                  <option key={list.drivername} value={list.drivername}>
                    {list.drivername}
                  </option>
                ))}
            </TextField>
            <TextField
              id="outlined-select-currency-native"
              select
              label="Vehicle Registration"
              value={vehicleRegistration}
              onChange={(e) => setVehicleRegistration(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="none">Choose</option>
              {chosenHaullier.length !== 0 &&
                chosenHaullier[0].vehicleslist?.map((list) => (
                  <option key={list.registration} value={list.registration}>
                    {list.registration}
                  </option>
                ))}
            </TextField>
            <TextField id="shippedvia" label="Shipped Via" type="text" autoComplete="current-text" />
            <TextField id="fobpoint" label="FOB Point" type="text" autoComplete="current-text" />
            <TextField id="tax" label="Tax" type="text" autoComplete="current-text" />
            <TextField
              id="outlined-select-currency-native"
              select
              label="Payment Method"
              value={method}
              onChange={(e) => setMethod(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="none">Choose</option>
              <option value="Cash">Cash</option>
              <option value="Cheque">Cheque</option>
              <option value="Credit">Credit</option>
            </TextField>
            <TextField id="others" label="Other Descriptions" multiline rows={4} />
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <div style={{ marginTop: 2, textAlign: 'center', width: '100%' }}>
            {loading ? (
              <Button variant="outlined" startIcon={<Progress />} disabled>
                Loading...
              </Button>
            ) : (
              <Button
                variant="outlined"
                startIcon={<EngineeringIcon />}
                size="large"
                onClick={addPurchaseOrder}
              >
                Issue Purchase Order
              </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarMessage.includes('success') ? 'success' : 'error'}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}